// Temporarily allow all
export default /^[^\W][^@]+$/;
